module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      F. Paul Wilson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("F. Paul Wilson is the author of more than fifty books spanning various genres, including science fiction, horror, thriller, and more. Four of his novels have been "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestsellers, and his work has earned him four Prometheus Awards, the prestigious Inkpot Award from the San Diego Comic-Con, and the Pioneer Award from the RT Booklovers Convention.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NQzRzL/tc-custom/9781429967372.jpg?1730634343926",
      "alt": "This image is the cover for the book All the Rage, Repairman Jack"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("All the Rage, Repairman Jack\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Repairman Jack must stop a new drug that unleashes otherworldly rage in this supernatural thriller by the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of "), _c('i', [_vm._v("The Tomb")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Can you imagine a new chemical compound that heightens your assertiveness, opening the door to your primal self and giving you a physical and mental edge wherever you compete? The non-addictive designer drug Berserk promises just that. It gives you a God-like feeling of supremacy . . . and releases uncontrollable rage that could turn you into a killer . . ."), _c('br'), _c('br'), _vm._v("Jack finds himself fighting the criminal forces behind Berserk. After combing New York City’s criminal underworld, Jack realizes that the drug comes from a most surprising source . . . a source that may have deadly effects on Jack’s life and the lives of those he cares most about . . ."), _c('br'), _c('br'), _c('b', [_vm._v("“One of the all-time great characters in one of the all-time great series.” —Lee Child")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0